export const ACTIVE_TEXT_BUTTON_COLOR = 'white';
export const DISABLED_CLOSE_BUTTON_COLOR = 'grey-300';
export const ENABLED_CLOSE_BUTTON_COLOR = 'grey-700';

export const STYLE_DEFAULT = 'default';
export const STYLE_OUTLINED = 'outlined';

export const STYLES = [STYLE_DEFAULT, STYLE_OUTLINED];
